import { createAction } from 'redux-actions';
import { THREAD_ID_CHANGED } from '../constants/actionTypes';
export const threadIdChanged = createAction(THREAD_ID_CHANGED);